import {
	Component,
	inject,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import { Validators } from '@angular/forms';
import * as Leaflet from 'leaflet';
import { Feature, Geometry } from 'geojson';
import { ValorPorGeocodigo } from '@componentes/mapa-paraiba-svg/mapa.interfaces';
import { CORES, coresQuantis } from '@componentes/mapa-paraiba-svg/legenda';
import { Select } from '@layout/interfaces/select';
import {
	capitalizeFirstLetter,
	baixarEAbrirPDF,
	numberToBrNumber,
	obter_erro_request,
	numberToBrNumberTables,
	verificaSePDFEAdicionaNaTabela,
	isNuloOuUndefined,
	isNotNuloOuUndefined,
} from '@utils';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subscription } from 'rxjs';
import { LegendaItem } from '../../../interfaces/legenda-de-cores';
import { DadosMapaQuantis } from '../../../interfaces/mapa-quantis-mensal';
import {
	ChuvasPorMicrorregiao,
	PrecipitacaoPorMunicipio,
} from '../../../interfaces/quantis-anual';
import {
	FormularioRelatorio,
	INPUTS_RELATORIOS_QUANTIS,
	InstanciaRelatorio,
} from '../../../interfaces/tipos-relatorios';
import { GraficosPrecipitacaoService } from '@home/submodulos/dados-meteorologicos/services';
import { MapasQuantisAnualService } from '../../../services/mapas-quantis-anual.service';
import { RelatoriosService } from '../../../services';
import html2canvas from 'html2canvas';
import * as pdfseira from '@utils/pdf-seira';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import { DocumentExporter } from '@utils/document-exporter';
import * as ExcelTable from 'mr-excel';
import { DateTimeUtils } from '@utils/datetime-util';
import { alinharDado } from '../../../../../../../shared/utils/index';
import { Municipio } from '../../../interfaces/filtros-opcoes';
import { HttpClient } from '@angular/common/http';

type MapCapture = {
	dataUrl: string;
	mapRect: { x: number; y: number; w: number; h: number };
	contentRect?: { x: number; y: number; w: number; h: number };
	canvasW: number;
	canvasH: number;
};

@Component({
	selector: 'seira-mapa-quantis',
	templateUrl: './mapa-quantis.component.html',
	styleUrls: ['./mapa-quantis.component.scss'],
})
export class MapaQuantisComponent
	implements OnInit, OnDestroy, InstanciaRelatorio
{
	@ViewChild('legendaMapaMobile') legendaMapaMobile!: TemplateRef<any>;
	inputs = inject(INPUTS_RELATORIOS_QUANTIS);
	microrregioes: Select[] = [];
	regioes: Select[] = [];
	municipios: Municipio[] = [];
	chuvaPorMunicipio: ValorPorGeocodigo[] = [];
	geocodigosRecorteMapa?: number[];
	informacoesRegioesMapa: {
		idRegiao: string | number;
		nomeRegiao: string;
		geocodigos: number[];
	}[] = [];
	delimitarRegioesMapa = false;
	mapaRegiaoPluviometrica!: Leaflet.Map;
	geoJsonRegiaoPluviometrica?: Leaflet.GeoJSON;
	private mapaLeafletPorMunicipio = false;
	estiloWrapperMapaRegiaoPluviometrica: Record<string, string> = {
		height: '500px',
		width: '100%',
		margin: '0 auto',
	};
	legendaItems: LegendaItem[] = [];
	tituloQuantis = '';
	dadosMapaQuantis: DadosMapaQuantis[] = [];
	chuvasPorMicrorregiao: ChuvasPorMicrorregiao[] = [];
	microrregiaoNome = '';
	loading = true;
	isDesktop = window.innerWidth > 1200;
	descricaoRelatorio = '';
	descricaoRelatorioMensal =
		'Define-se como quantis mensais, os valores que dividem uma amostra de dados mensais em percentis, permitindo a análise de diferentes categorias pluviométricas em determinado local ou região.';
	descricaoRelatorioAnual =
		'Define-se como quantis anuais, os valores que dividem uma amostra de dados anuais em percentis, permitindo a análise de diferentes categorias pluviométricas em determinado local ou região.';
	legenda =
		'Os limiares utilizados para definir a precipitação mensal, na geração dos gráficos e mapas de quantis originaram-se do estudo intitulado: Determinação De Limiares para A Precipitação Mensal Das Regiões Homogêneas Da Paraíba Usando Quantis dos autores: Silva, E. A. da, Brito, J. I. B. de, Becker, C. T., Mandú, T. B., & Lima, I. P. C., publicado em 2022, pela Revista Brasileira de Climatologia ISSN - 2237-8642.';
	relatorioService = inject(RelatoriosService);
	private isExporting = false;
	private readonly exportScale = 2;
	private readonly exportDesktopWidth = 993;
	private readonly exportMapHeight = 500;
	readonly coresLegendaEscalaPluviometrica = [
		'#f71920',
		'#ff3338',
		'#ff5b35',
		'#ffa66e',
		'#f8c997',
		'#ffff99',
		'#7dff00',
		'#70d56d',
		'#29ca2f',
		'#009b3a',
		'#159ced',
		'#127df2',
		'#0b62ef',
	];
	readonly valoresLegendaEscalaPluviometrica = [
		'0,0',
		'0,1',
		'10,0',
		'20,0',
		'30,0',
		'50,0',
		'100,0',
		'150,0',
		'200,0',
		'250,0',
		'300,0',
		'350,0',
		'400,0',
	];

	botoesDeExportacao: GroupButton[] = [
		{
			label: '.png',
			size: 'small',
			icon: 'ph-image',
			onClick: () => this.exportarPNG(),
		},
		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			onClick: () => {
				return this.exportarPDF();
			},
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => this.exportarCSV(),
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => this.exportarTXT(),
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => this.exportarXLSX(),
		},
	];

	private subscription = new Subscription();

	constructor(
		private mapasQuantisAnualService: MapasQuantisAnualService,
		private graficosPrecipitacaoService: GraficosPrecipitacaoService,
		private toastr: ToastrService,
		private httpClient: HttpClient
	) {
		this.setValidators();
	}

	ngOnInit() {
		this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.setValue('mensal', { emitEvent: false });

		const periodoBusca = this.inputs.form.get('periodoBusca')?.value;

		this.descricaoRelatorio =
			periodoBusca === 'mensal'
				? this.descricaoRelatorioMensal
				: this.descricaoRelatorioAnual;
	}

	ngOnDestroy() {
		this.inputs.form.get(FormularioRelatorio.AGRUPAMENTO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.PERIODO_BUSCA)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.PERIODO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.MICRORREGIAO)?.clearValidators();
		this.inputs.form
			.get(FormularioRelatorio.REGIAO_PLUVIOMETRICA)
			?.clearValidators();
		this.geoJsonRegiaoPluviometrica?.remove();
		this.mapaRegiaoPluviometrica?.remove();
		this.subscription.unsubscribe();
	}

	setValidators() {
		this.inputs.form
			.get(FormularioRelatorio.AGRUPAMENTO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.PERIODO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.MICRORREGIAO)
			?.setValidators(Validators.required);
		this.inputs.form
			.get(FormularioRelatorio.REGIAO_PLUVIOMETRICA)
			?.setValidators(Validators.required);
	}

	gerarRelatorio() {
		if (this.inputs.form.invalid) {
			return;
		}
		const periodo = this.inputs.form.get('periodo')?.value;
		const periodoBusca = this.inputs.form.get('periodoBusca')?.value;
		const opcoesAgrupamento = this.getOpcoesAgrupamentoSelecionado();
		const valorAgrupamento = Number(
			this.inputs.form.get(this.getCampoAgrupamentoSelecionado())?.value
		);
		const agrupamentoSelect = opcoesAgrupamento.find(
			value => Number(value.value) === valorAgrupamento
		);
		this.microrregiaoNome = agrupamentoSelect ? agrupamentoSelect.name : '';
		this.geocodigosRecorteMapa = undefined;
		this.atualizarConfiguracaoMapaRegiaoPluviometrica(valorAgrupamento);
		const regioesIds = this.getIdsConsultaQuantis(
			valorAgrupamento,
			opcoesAgrupamento
		);

		this.descricaoRelatorio =
			periodoBusca === 'mensal'
				? this.descricaoRelatorioMensal
				: this.descricaoRelatorioAnual;

		this.tituloQuantis = `${this.getTituloLegenda()} - ${capitalizeFirstLetter(
			this.microrregiaoNome
		)} - ${DateTimeUtils.formatarDataPeriodo(periodo, '', periodoBusca, true)}`;

		this.loading = true;
		this.inputs.setLoading(true);
		if (this.getTipo() === 'QUANTIS_MENSAL') {
			this.graficosPrecipitacaoService
				.buscarMapaQuantisMensal(regioesIds, null, periodo)
				.subscribe({
					next: resp => {
						this.relatorioService.atualizaVisibilidadeBotoesExportacao(true);
						this.dadosMapaQuantis = resp;
						this.chuvaPorMunicipio = [];
						if (Array.isArray(resp) && resp.length > 0) {
							resp.forEach((resp: DadosMapaQuantis) => {
								if (resp && resp.precipitacoesMunicipios) {
									resp.precipitacoesMunicipios.forEach(
										(precipitacaoPorMunicipio: PrecipitacaoPorMunicipio) => {
											this.chuvaPorMunicipio.push({
												valor: precipitacaoPorMunicipio.precipitacaoAcumulada,
												geocodigo: precipitacaoPorMunicipio.geocodigo,
												ranges: precipitacaoPorMunicipio.quantisValores,
												data: precipitacaoPorMunicipio,
											});
										}
									);
								}
							});
						}
						this.atualizarRecorteRegiaoPluviometrica();
						this.loading = false;
						this.inputs.setLoading(false);
						setTimeout(() => this.renderizarMapaRegiaoPluviometrica(), 0);
					},
					error: erro => {
						this.loading = false;
						this.inputs.setLoading(false);
						const msg_erro = obter_erro_request(erro);
						this.toastr.error(
							msg_erro,
							'Erro ao obter informações do posto selecionado'
						);
					},
				});
		} else {
			this.mapasQuantisAnualService
				.buscarMapaQuantisAnual({
					regioesIds: regioesIds,
					diaInicio: periodo,
					diaFim: periodo,
				})
				.subscribe({
					next: resp => {
						this.relatorioService.atualizaVisibilidadeBotoesExportacao(true);
						this.chuvasPorMicrorregiao = resp;
						this.chuvaPorMunicipio = [];
						if (Array.isArray(resp) && resp.length > 0) {
							resp.forEach((resp: ChuvasPorMicrorregiao) => {
								if (resp && resp.precipitacoesMunicipios) {
									resp.precipitacoesMunicipios.forEach(
										(micro: PrecipitacaoPorMunicipio) => {
											this.chuvaPorMunicipio.push({
												valor: micro.precipitacaoAcumulada,
												geocodigo: micro.geocodigo,
												ranges: micro.quantisValores,
												data: micro,
											});
										}
									);
								}
							});
						}
						this.atualizarRecorteRegiaoPluviometrica();
						this.loading = false;
						this.inputs.setLoading(false);
						setTimeout(() => this.renderizarMapaRegiaoPluviometrica(), 0);
					},
					error: erro => {
						this.loading = false;
						this.inputs.setLoading(false);
						const msg_erro = obter_erro_request(erro);
						this.toastr.error(
							msg_erro,
							'Erro ao obter informações do posto selecionado'
						);
					},
				});
		}
	}

	private getAgrupamentoSelecionado(): string {
		return (
			this.inputs.form.get(FormularioRelatorio.AGRUPAMENTO)?.value ??
			'MICRORREGIAO'
		);
	}

	private getCampoAgrupamentoSelecionado(): FormularioRelatorio {
		return this.getAgrupamentoSelecionado() === 'REGIAO_PLUVIOMETRICA'
			? FormularioRelatorio.REGIAO_PLUVIOMETRICA
			: FormularioRelatorio.MICRORREGIAO;
	}

	private getOpcoesAgrupamentoSelecionado(): Select[] {
		return this.getAgrupamentoSelecionado() === 'REGIAO_PLUVIOMETRICA'
			? this.regioes
			: this.microrregioes;
	}

	private getIdsConsultaQuantis(
		valorAgrupamento: number,
		opcoesAgrupamento: Select[]
	): number[] {
		if (this.getAgrupamentoSelecionado() !== 'REGIAO_PLUVIOMETRICA') {
			return valorAgrupamento === 0
				? opcoesAgrupamento
						.filter(opcao => opcao.value !== '0')
						.map(opcao => Number(opcao.value))
				: [Number(valorAgrupamento)];
		}

		const microrregioesIds = this.microrregioes
			.filter(opcao => opcao.value !== '0')
			.map(opcao => Number(opcao.value))
			.filter(Boolean);

		return microrregioesIds.length
			? microrregioesIds
			: opcoesAgrupamento
					.filter(opcao => opcao.value !== '0')
					.map(opcao => Number(opcao.value));
	}

	private atualizarRecorteRegiaoPluviometrica() {
		const regiaoSelecionada = this.inputs.form.get(
			FormularioRelatorio.REGIAO_PLUVIOMETRICA
		)?.value;

		if (
			this.getAgrupamentoSelecionado() !== 'REGIAO_PLUVIOMETRICA' ||
			regiaoSelecionada === '0'
		) {
			this.geocodigosRecorteMapa = undefined;
			return;
		}

		const geocodigosDaRegiao = this.inputs.municipios
			.filter(
				municipio => Number(municipio.regiao) === Number(regiaoSelecionada)
			)
			.map(municipio => municipio.geocodigo);
		const geocodigosComDados = this.chuvaPorMunicipio.map(
			municipio => municipio.geocodigo
		);

		this.geocodigosRecorteMapa = Array.from(
			new Set(
				geocodigosDaRegiao.length ? geocodigosDaRegiao : geocodigosComDados
			)
		);
	}

	setupMapaRegiaoPluviometrica(mapa: Leaflet.Map) {
		this.mapaRegiaoPluviometrica = mapa;
		this.mapaRegiaoPluviometrica.attributionControl?.remove();
		this.mapaRegiaoPluviometrica.zoomControl?.remove();
		this.bloquearInteracaoMapaLeaflet();
		this.removerCamadasBaseMapaQuantis();
		setTimeout(() => {
			this.removerCamadasBaseMapaQuantis();
			this.mapaRegiaoPluviometrica.invalidateSize();
			this.bloquearInteracaoMapaLeaflet();
			this.renderizarMapaRegiaoPluviometrica();
		}, 0);
	}

	private renderizarMapaRegiaoPluviometrica() {
		if (
			!this.mapaRegiaoPluviometrica ||
			this.getAgrupamentoSelecionado() !== 'REGIAO_PLUVIOMETRICA'
		) {
			return;
		}

		this.geoJsonRegiaoPluviometrica?.remove();
		this.geoJsonRegiaoPluviometrica?.clearLayers();

		const regiaoSelecionada = this.inputs.form.get(
			FormularioRelatorio.REGIAO_PLUVIOMETRICA
		)?.value;
		const estadoCompleto = regiaoSelecionada === '0';
		this.mapaLeafletPorMunicipio = !estadoCompleto;

		this.atualizarLegendaMapaLeaflet(
			estadoCompleto,
			this.mapaLeafletPorMunicipio
		);

		if (!estadoCompleto) {
			forkJoin({
				municipios: this.httpClient.get<GeoJSON.GeoJsonObject>(
					'assets/geoJson/pb-municipios-geo.json'
				),
				regioes: this.httpClient.get<GeoJSON.GeoJsonObject>(
					'assets/geoJson/pb-regioes-pluviometricas-geo.json'
				),
			}).subscribe(({ municipios, regioes }) => {
				const regiaoFeature = this.getFeatureRegiaoSelecionada(regioes);
				this.renderizarGeoJsonRegiaoPluviometrica(
					municipios,
					estadoCompleto,
					regiaoFeature
				);
			});
			return;
		}

		this.httpClient
			.get<GeoJSON.GeoJsonObject>(
				'assets/geoJson/pb-regioes-pluviometricas-geo.json'
			)
			.subscribe(value => {
				this.renderizarGeoJsonRegiaoPluviometrica(value, estadoCompleto);
			});
	}

	private renderizarGeoJsonRegiaoPluviometrica(
		value: GeoJSON.GeoJsonObject,
		estadoCompleto: boolean,
		regiaoFeature?: Feature<Geometry, any>
	) {
		const renderer = Leaflet.canvas({ padding: 0.5 });
		const featureCollection = value as GeoJSON.FeatureCollection<Geometry, any>;

		if (!estadoCompleto && regiaoFeature) {
			this.geocodigosRecorteMapa = featureCollection.features
				.filter(feature =>
					this.municipioPertenceAoRecorteGeometrico(feature, regiaoFeature)
				)
				.map(feature => this.getGeocodigoFeature(feature))
				.filter(Boolean);
			this.atualizarLegendaMapaLeaflet(false, true);
		}

		this.geoJsonRegiaoPluviometrica = Leaflet.geoJSON(value, {
			renderer,
			filter: (feature?: Feature<Geometry, any>) =>
				estadoCompleto ||
				(regiaoFeature
					? this.municipioPertenceAoRecorteGeometrico(feature, regiaoFeature)
					: this.municipioPertenceAoRecorte(feature)),
			style: (feature?: Feature<Geometry, any>) =>
				estadoCompleto
					? this.estiloRegiaoPluviometrica(feature)
					: this.estiloMunicipioQuantis(feature),
			onEachFeature: (
				feature: Feature<Geometry, any>,
				layer: Leaflet.Layer
			) => {
				layer.bindTooltip(this.getNomeFeatureMapa(feature), {
					direction: 'top',
					sticky: true,
					opacity: 0.95,
					className: 'mapa-quantis-tooltip',
				});
				layer.on({
					click: (e: Leaflet.LeafletMouseEvent) => {
						const popupOptions = this.getPopupOptionsMapaQuantis();
						layer
							.bindPopup(this.getPopupMapaLeafletV2(feature), popupOptions)
							.openPopup(
								this.getLatLngPopupVisivel(
									e.latlng,
									popupOptions.maxWidth ?? 280,
									this.getAlturaEstimadaPopup(feature)
								)
							);
					},
				});
			},
		} as any).addTo(this.mapaRegiaoPluviometrica);

		const bounds = this.geoJsonRegiaoPluviometrica.getBounds();
		if (bounds.isValid()) {
			this.atualizarEstiloWrapperMapaRegiaoPluviometrica(
				bounds,
				estadoCompleto
			);
			this.aplicarEnquadramentoMapaRegiaoPluviometrica(bounds, estadoCompleto);
		}
		this.agendarLimpezaCamadasBaseMapaQuantis();
		this.bloquearInteracaoMapaLeaflet();
	}

	private atualizarEstiloWrapperMapaRegiaoPluviometrica(
		bounds: Leaflet.LatLngBounds,
		estadoCompleto: boolean
	) {
		if (estadoCompleto || !this.mapaRegiaoPluviometrica) {
			this.estiloWrapperMapaRegiaoPluviometrica = {
				height: '500px',
				width: '100%',
				maxWidth: '100%',
				margin: '0 auto',
			};
			return;
		}

		const west = bounds.getWest();
		const east = bounds.getEast();
		const south = bounds.getSouth();
		const north = bounds.getNorth();
		const latitudeMedia = ((south + north) / 2) * (Math.PI / 180);
		const larguraGeografica = Math.abs(east - west) * Math.cos(latitudeMedia);
		const alturaGeografica = Math.abs(north - south);
		const proporcao = alturaGeografica
			? larguraGeografica / alturaGeografica
			: 1;
		const alturaDisponivel =
			proporcao < 0.55 ? 660 : proporcao < 0.9 ? 600 : 560;

		this.estiloWrapperMapaRegiaoPluviometrica = {
			height: `${alturaDisponivel}px`,
			minHeight: `${alturaDisponivel}px`,
			width: '100%',
			maxWidth: '100%',
			margin: '0 auto',
		};
	}

	private aplicarEnquadramentoMapaRegiaoPluviometrica(
		bounds: Leaflet.LatLngBounds,
		estadoCompleto: boolean
	) {
		if (!this.mapaRegiaoPluviometrica) {
			return;
		}

		const padding = this.getPaddingMapaRegiaoPluviometrica(estadoCompleto);
		this.mapaRegiaoPluviometrica.setMinZoom(0);
		this.mapaRegiaoPluviometrica.setMaxZoom(18);

		requestAnimationFrame(() => {
			this.mapaRegiaoPluviometrica?.invalidateSize(true);

			requestAnimationFrame(() => {
				if (!this.mapaRegiaoPluviometrica) {
					return;
				}

				const container = this.mapaRegiaoPluviometrica.getContainer();
				if (!container.clientWidth || !container.clientHeight) {
					setTimeout(() => {
						this.mapaRegiaoPluviometrica?.invalidateSize(true);
						this.aplicarFitBoundsMapaRegiaoPluviometrica(
							bounds,
							padding,
							estadoCompleto
						);
					}, 0);
					return;
				}

				this.aplicarFitBoundsMapaRegiaoPluviometrica(
					bounds,
					padding,
					estadoCompleto
				);
			});
		});
	}

	private aplicarFitBoundsMapaRegiaoPluviometrica(
		bounds: Leaflet.LatLngBounds,
		padding: Leaflet.PointTuple,
		estadoCompleto: boolean
	) {
		if (!this.mapaRegiaoPluviometrica) {
			return;
		}

		this.mapaRegiaoPluviometrica.fitBounds(bounds, {
			padding,
			maxZoom: estadoCompleto ? 8 : 12,
			animate: false,
		});

		const zoomAtual = this.mapaRegiaoPluviometrica.getZoom();
		this.centralizarBoundsMapaRegiaoPluviometrica(bounds, zoomAtual);
		this.mapaRegiaoPluviometrica.setMinZoom(zoomAtual);
		this.mapaRegiaoPluviometrica.setMaxZoom(zoomAtual);
	}

	private centralizarBoundsMapaRegiaoPluviometrica(
		bounds: Leaflet.LatLngBounds,
		zoomAtual: number
	) {
		if (!this.mapaRegiaoPluviometrica) {
			return;
		}

		this.mapaRegiaoPluviometrica.invalidateSize(true);

		const northWest = this.mapaRegiaoPluviometrica.latLngToContainerPoint(
			bounds.getNorthWest()
		);
		const southEast = this.mapaRegiaoPluviometrica.latLngToContainerPoint(
			bounds.getSouthEast()
		);
		const centroGeometria = Leaflet.point(
			(northWest.x + southEast.x) / 2,
			(northWest.y + southEast.y) / 2
		);
		const tamanhoMapa = this.mapaRegiaoPluviometrica.getSize();
		const centroContainer = Leaflet.point(tamanhoMapa.x / 2, tamanhoMapa.y / 2);
		const deslocamento = centroGeometria.subtract(centroContainer);

		if (deslocamento.x !== 0 || deslocamento.y !== 0) {
			this.mapaRegiaoPluviometrica.panBy(deslocamento, {
				animate: false,
			});
		}

		if (this.mapaRegiaoPluviometrica.getZoom() !== zoomAtual) {
			this.mapaRegiaoPluviometrica.setZoom(zoomAtual, { animate: false });
		}
	}

	private getPaddingMapaRegiaoPluviometrica(
		estadoCompleto: boolean
	): Leaflet.PointTuple {
		return estadoCompleto ? [20, 20] : [6, 6];
	}

	private getPopupOptionsMapaQuantis(): Leaflet.PopupOptions {
		return {
			autoPan: false,
			keepInView: false,
			closeButton: false,
			maxWidth: 300,
			minWidth: 250,
			offset: Leaflet.point(0, -10),
			className: 'mapa-quantis-popup',
		};
	}

	private getAlturaEstimadaPopup(feature?: Feature<Geometry, any>): number {
		const dadoMunicipio = this.getDadoMunicipioPorFeature(feature);
		return dadoMunicipio ? 170 : 120;
	}

	private getLatLngPopupVisivel(
		latlng: Leaflet.LatLng,
		larguraPopup: number,
		alturaPopup: number
	): Leaflet.LatLng {
		if (!this.mapaRegiaoPluviometrica) {
			return latlng;
		}

		const container = this.mapaRegiaoPluviometrica.getContainer();
		const ponto = this.mapaRegiaoPluviometrica.latLngToContainerPoint(latlng);
		const margem = 16;
		const metadeLargura = larguraPopup / 2;
		const x = Math.min(
			Math.max(ponto.x, metadeLargura + margem),
			container.clientWidth - metadeLargura - margem
		);
		const y = Math.min(
			Math.max(ponto.y, alturaPopup + margem),
			container.clientHeight - 20
		);

		return this.mapaRegiaoPluviometrica.containerPointToLatLng(
			Leaflet.point(x, y)
		);
	}

	private bloquearInteracaoMapaLeaflet() {
		if (!this.mapaRegiaoPluviometrica) return;

		this.mapaRegiaoPluviometrica.dragging.disable();
		this.mapaRegiaoPluviometrica.scrollWheelZoom.disable();
		this.mapaRegiaoPluviometrica.doubleClickZoom.disable();
		this.mapaRegiaoPluviometrica.boxZoom.disable();
		this.mapaRegiaoPluviometrica.keyboard.disable();
		this.mapaRegiaoPluviometrica.touchZoom.disable();
		(this.mapaRegiaoPluviometrica as any).tap?.disable?.();
	}

	private removerCamadasBaseMapaQuantis() {
		if (!this.mapaRegiaoPluviometrica) return;

		this.mapaRegiaoPluviometrica.eachLayer(layer => {
			if (layer instanceof Leaflet.TileLayer || (layer as any)._url) {
				this.mapaRegiaoPluviometrica.removeLayer(layer);
			}
		});

		const container = this.mapaRegiaoPluviometrica.getContainer();
		container.style.background = 'transparent';
		const panes = this.mapaRegiaoPluviometrica.getPanes();
		panes.mapPane.style.background = 'transparent';
		panes.overlayPane.style.background = 'transparent';

		const tilePane = this.mapaRegiaoPluviometrica.getPane('tilePane');
		if (tilePane) {
			tilePane.innerHTML = '';
			tilePane.style.display = 'none';
			tilePane.style.pointerEvents = 'none';
		}

		const labelsPane = this.mapaRegiaoPluviometrica.getPane('labels');
		if (labelsPane) {
			labelsPane.innerHTML = '';
			labelsPane.style.display = 'none';
			labelsPane.style.pointerEvents = 'none';
		}
	}

	private agendarLimpezaCamadasBaseMapaQuantis() {
		this.removerCamadasBaseMapaQuantis();
		setTimeout(() => this.removerCamadasBaseMapaQuantis(), 0);
		setTimeout(() => this.removerCamadasBaseMapaQuantis(), 150);
	}

	private deveFiltrarExportacaoPorRecorteRegiaoPluviometrica(): boolean {
		const regiaoSelecionada = this.inputs.form.get(
			FormularioRelatorio.REGIAO_PLUVIOMETRICA
		)?.value;

		return (
			this.getAgrupamentoSelecionado() === 'REGIAO_PLUVIOMETRICA' &&
			regiaoSelecionada !== '0' &&
			!!this.geocodigosRecorteMapa?.length
		);
	}

	private deveAplicarAjustesExportacaoRegiaoPluviometrica(): boolean {
		return this.getAgrupamentoSelecionado() === 'REGIAO_PLUVIOMETRICA';
	}

	private ordenarMunicipiosExportacaoRegiaoPluviometrica(
		precipitacoesMunicipios: PrecipitacaoPorMunicipio[]
	): PrecipitacaoPorMunicipio[] {
		if (!this.deveAplicarAjustesExportacaoRegiaoPluviometrica()) {
			return precipitacoesMunicipios;
		}

		return [...precipitacoesMunicipios].sort((municipioA, municipioB) =>
			(municipioA.nomeMunicipio ?? '').localeCompare(
				municipioB.nomeMunicipio ?? '',
				'pt-BR',
				{ sensitivity: 'base' }
			)
		);
	}

	private formatarValorQuantisExportacaoTexto(
		valor: number | null | undefined
	): string {
		if (
			!this.deveAplicarAjustesExportacaoRegiaoPluviometrica() ||
			isNuloOuUndefined(valor) ||
			Number.isNaN(Number(valor))
		) {
			return numberToBrNumberTables(valor, 1);
		}

		return Number(valor).toLocaleString('pt-BR', {
			minimumFractionDigits: 1,
			maximumFractionDigits: 1,
		});
	}

	private getPrecipitacoesMunicipiosParaExportacao(
		dados: Array<{ precipitacoesMunicipios?: PrecipitacaoPorMunicipio[] }>
	): PrecipitacaoPorMunicipio[] {
		const geocodigosPermitidos =
			this.deveFiltrarExportacaoPorRecorteRegiaoPluviometrica()
				? new Set(
						this.geocodigosRecorteMapa?.map(geocodigo => Number(geocodigo))
				  )
				: undefined;
		const chavesAdicionadas = new Set<string>();
		const precipitacoesMunicipios: PrecipitacaoPorMunicipio[] = [];

		dados.forEach(item => {
			item.precipitacoesMunicipios?.forEach(precipitacaoMunicipio => {
				const geocodigo = Number(precipitacaoMunicipio.geocodigo);

				if (geocodigosPermitidos && !geocodigosPermitidos.has(geocodigo)) {
					return;
				}

				const chave = `${geocodigo}-${precipitacaoMunicipio.periodo}`;
				if (chavesAdicionadas.has(chave)) {
					return;
				}

				chavesAdicionadas.add(chave);
				precipitacoesMunicipios.push(precipitacaoMunicipio);
			});
		});

		return this.ordenarMunicipiosExportacaoRegiaoPluviometrica(
			precipitacoesMunicipios
		);
	}

	private municipioPertenceAoRecorte(
		feature?: Feature<Geometry, any>
	): boolean {
		const geocodigo = this.getGeocodigoFeature(feature);

		return !!geocodigo && !!this.geocodigosRecorteMapa?.includes(geocodigo);
	}

	private getFeatureRegiaoSelecionada(
		geoJson: GeoJSON.GeoJsonObject
	): Feature<Geometry, any> | undefined {
		const regiaoSelecionada = this.inputs.form.get(
			FormularioRelatorio.REGIAO_PLUVIOMETRICA
		)?.value;
		const collection = geoJson as GeoJSON.FeatureCollection<Geometry, any>;
		const nomeRegiaoSelecionada = this.normalizarNome(this.microrregiaoNome);

		const featurePorNome = collection.features?.find(
			feature =>
				this.normalizarNome(feature.properties?.name ?? '') ===
				nomeRegiaoSelecionada
		);
		if (featurePorNome) return featurePorNome;

		return collection.features?.find(feature => {
			const idRegiao = this.getIdRegiaoFeature(feature);
			return Number(idRegiao) === Number(regiaoSelecionada);
		});
	}

	private municipioPertenceAoRecorteGeometrico(
		municipioFeature?: Feature<Geometry, any>,
		regiaoFeature?: Feature<Geometry, any>
	): boolean {
		const pontoMunicipio = this.getPontoRepresentativoFeature(municipioFeature);
		if (!pontoMunicipio || !regiaoFeature?.geometry) return false;

		return this.pontoDentroDaGeometria(pontoMunicipio, regiaoFeature.geometry);
	}

	private getPontoRepresentativoFeature(
		feature?: Feature<Geometry, any>
	): [number, number] | undefined {
		const pontos = this.getPontosGeometria(feature?.geometry);
		if (!pontos.length) return undefined;

		const total = pontos.reduce(
			(acc, ponto) => {
				acc[0] += ponto[0];
				acc[1] += ponto[1];
				return acc;
			},
			[0, 0]
		);

		return [total[0] / pontos.length, total[1] / pontos.length];
	}

	private getPontosGeometria(geometry?: Geometry): [number, number][] {
		if (!geometry) return [];

		if (geometry.type === 'Polygon') {
			return (geometry.coordinates[0] ?? []) as [number, number][];
		}

		if (geometry.type === 'MultiPolygon') {
			return geometry.coordinates.flatMap(
				polygon => (polygon[0] ?? []) as [number, number][]
			);
		}

		return [];
	}

	private pontoDentroDaGeometria(
		ponto: [number, number],
		geometry: Geometry
	): boolean {
		if (geometry.type === 'Polygon') {
			return this.pontoDentroDoPoligono(ponto, geometry.coordinates);
		}

		if (geometry.type === 'MultiPolygon') {
			return geometry.coordinates.some(polygon =>
				this.pontoDentroDoPoligono(ponto, polygon)
			);
		}

		return false;
	}

	private pontoDentroDoPoligono(
		ponto: [number, number],
		poligono: number[][][]
	): boolean {
		const [x, y] = ponto;
		const anelExterno = poligono[0] ?? [];
		let dentro = false;

		for (
			let i = 0, j = anelExterno.length - 1;
			i < anelExterno.length;
			j = i++
		) {
			const xi = anelExterno[i][0];
			const yi = anelExterno[i][1];
			const xj = anelExterno[j][0];
			const yj = anelExterno[j][1];
			const intersecta =
				yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

			if (intersecta) dentro = !dentro;
		}

		if (!dentro) return false;

		const buracos = poligono.slice(1);
		return !buracos.some(anel => this.pontoDentroDoPoligono(ponto, [anel]));
	}

	private regiaoPertenceAoRecorte(feature?: Feature<Geometry, any>): boolean {
		return (
			this.normalizarNome(feature?.properties?.name ?? '') ===
			this.normalizarNome(this.microrregiaoNome)
		);
	}

	private estiloRegiaoPluviometrica(feature?: Feature<Geometry, any>) {
		return this.getEstiloLeaflet(this.getCorRegiaoPluviometricaPorMm(feature));
	}

	private estiloMunicipioQuantis(feature?: Feature<Geometry, any>) {
		const dadoMunicipio = this.getDadoMunicipioPorFeature(feature);
		const indiceCor = this.getIndiceCorQuantis(dadoMunicipio);

		return this.getEstiloLeaflet(coresQuantis[indiceCor]);
	}

	private getEstiloLeaflet(fillColor: string): Leaflet.PathOptions {
		return {
			fillColor,
			weight: 1.2,
			opacity: 1,
			color: '#546E7A',
			lineJoin: 'round' as Leaflet.LineJoinShape,
			lineCap: 'round' as Leaflet.LineCapShape,
			fillOpacity: 1,
		};
	}

	private getPopupMapaLeaflet(feature?: Feature<Geometry, any>): string {
		const regiaoSelecionada = this.inputs.form.get(
			FormularioRelatorio.REGIAO_PLUVIOMETRICA
		)?.value;
		const estadoCompleto = regiaoSelecionada === '0';

		if (estadoCompleto || !this.mapaLeafletPorMunicipio) {
			const nomeRegiao = feature?.properties?.name ?? 'Região';
			const qtdDados = this.getDadosRegiaoFeature(feature).length;

			return this.getPopupHtml(
				nomeRegiao,
				`Municípios com dados: ${qtdDados}`,
				this.getCorRegiaoPluviometricaPorMm(feature)
			);
		}

		const dadoMunicipio = this.getDadoMunicipioPorFeature(feature);
		const nomeMunicipio =
			dadoMunicipio?.data?.nomeMunicipio ??
			dadoMunicipio?.data?.nome ??
			feature?.properties?.name ??
			'Município';
		const precipitacao = isNotNuloOuUndefined(dadoMunicipio?.valor)
			? `${numberToBrNumber(dadoMunicipio?.valor, 1)} mm`
			: 'Sem informação';

		return this.getPopupHtml(
			nomeMunicipio,
			`Precipitação: ${precipitacao}`,
			coresQuantis[this.getIndiceCorQuantis(dadoMunicipio)]
		);
	}

	private getPopupMapaLeafletV2(feature?: Feature<Geometry, any>): string {
		const regiaoSelecionada = this.inputs.form.get(
			FormularioRelatorio.REGIAO_PLUVIOMETRICA
		)?.value;
		const estadoCompleto = regiaoSelecionada === '0';

		if (estadoCompleto || !this.mapaLeafletPorMunicipio) {
			const nomeRegiao = feature?.properties?.name ?? 'Regiao';
			const precipitacao = this.getPrecipitacaoMediaRegiao(feature);
			const texto = isNotNuloOuUndefined(precipitacao)
				? `Precipitação: ${numberToBrNumber(precipitacao, 1)} mm`
				: 'Precipitação: Sem informação';

			return this.getPopupHtmlV2(
				nomeRegiao,
				texto,
				this.getCorRegiaoPluviometricaPorMm(feature)
			);
		}

		const dadoMunicipio = this.getDadoMunicipioPorFeature(feature);
		const nomeMunicipio =
			dadoMunicipio?.data?.nomeMunicipio ??
			dadoMunicipio?.data?.nome ??
			feature?.properties?.name ??
			'Municipio';
		const precipitacao = isNotNuloOuUndefined(dadoMunicipio?.valor)
			? `${numberToBrNumber(dadoMunicipio?.valor, 1)} mm`
			: 'Sem informação';

		return this.getPopupHtmlV2(
			nomeMunicipio,
			`Precipitação: ${precipitacao}`,
			coresQuantis[this.getIndiceCorQuantis(dadoMunicipio)],
			dadoMunicipio
		);
	}

	private getPopupHtmlV2(
		titulo: string,
		texto: string,
		cor: string,
		dadoMunicipio?: ValorPorGeocodigo
	): string {
		const corTextoHeader = this.getCorTextoPopup(cor);
		const textoFormatado = texto.replace(/^Precipitação:/, 'Precipitação:');

		if (dadoMunicipio) {
			const precipitacao = isNotNuloOuUndefined(dadoMunicipio.valor)
				? `${numberToBrNumber(dadoMunicipio.valor, 1)} mm`
				: 'Sem informação';
			const classificacao = this.getClassificacaoQuantis(dadoMunicipio);

			return `
				<div style="min-width: 230px; max-width: 280px; overflow: hidden; border-radius: 6px; background: #fff;">
					<div style="background: ${cor}; color: ${corTextoHeader}; padding: 11px 14px; font-weight: 700; font-size: 15px; display: flex; align-items: center; gap: 9px;">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="${corTextoHeader}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
							<path d="M20 10c0 4.5-5.2 10.1-7.2 12a1.1 1.1 0 0 1-1.6 0C9.2 20.1 4 14.5 4 10a8 8 0 0 1 16 0Z"></path>
							<circle cx="12" cy="10" r="3"></circle>
						</svg>
						<span>${titulo}</span>
					</div>
					<div style="padding: 14px 14px 16px; color: #5d6970; font-weight: 600;">
						<div style="display: flex; align-items: center; gap: 8px; font-size: 20px; line-height: 1.15;">
							<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5d6970" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex: 0 0 auto;">
								<path d="M12 2.7 6.9 9.1a8 8 0 1 0 10.2 0L12 2.7Z"></path>
							</svg>
							<span>${precipitacao}</span>
						</div>
						<div style="font-size: 13px; margin-top: 8px;">precipitação acumulada</div>
						<div style="font-size: 13px; margin-top: 10px;">${classificacao}</div>
					</div>
				</div>`;
		}

		return `
			<div style="min-width: 220px; max-width: 280px; overflow: hidden; border-radius: 6px; background: #fff;">
				<div style="background: ${cor}; color: ${corTextoHeader}; padding: 11px 14px; font-weight: 700; font-size: 15px; display: flex; align-items: center; gap: 9px;">
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="${corTextoHeader}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
						<path d="M20 10c0 4.5-5.2 10.1-7.2 12a1.1 1.1 0 0 1-1.6 0C9.2 20.1 4 14.5 4 10a8 8 0 0 1 16 0Z"></path>
						<circle cx="12" cy="10" r="3"></circle>
					</svg>
					<span>${titulo}</span>
				</div>
				<div style="padding: 14px; color: #475569; font-size: 13px; font-weight: 600; display: flex; align-items: center; gap: 9px; line-height: 1.4;">
					<svg width="24" height="18" viewBox="0 0 34 24" fill="none" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex: 0 0 auto;">
						<path d="M25.5 22H9.5a7.5 7.5 0 0 1-1.2-14.9A10.5 10.5 0 0 1 29 10.5 6 6 0 0 1 25.5 22Z"></path>
					</svg>
					<span>${textoFormatado}</span>
				</div>
			</div>`;
	}

	private getNomeFeatureMapa(feature?: Feature<Geometry, any>): string {
		const dadoMunicipio = this.getDadoMunicipioPorFeature(feature);

		return (
			dadoMunicipio?.data?.nomeMunicipio ??
			dadoMunicipio?.data?.nome ??
			feature?.properties?.name ??
			''
		);
	}

	private getClassificacaoQuantis(dadoMunicipio?: ValorPorGeocodigo): string {
		const indice = this.getIndiceCorQuantis(dadoMunicipio);

		return this.getLegendaQuantisZerada()[indice].label;
	}

	private getCorTextoPopup(cor: string): string {
		const hex = cor.replace('#', '');
		if (hex.length !== 6) return '#ffffff';

		const r = parseInt(hex.slice(0, 2), 16);
		const g = parseInt(hex.slice(2, 4), 16);
		const b = parseInt(hex.slice(4, 6), 16);
		const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

		return luminancia > 0.72 ? '#64748b' : '#ffffff';
	}

	private getPopupHtml(titulo: string, texto: string, cor: string): string {
		return `
			<div style="min-width: 230px; overflow: hidden; border-radius: 4px; background: #fff;">
				<div style="background: ${cor}; color: #475569; padding: 12px 16px; font-weight: 700; font-size: 18px;">
					${titulo}
				</div>
				<div style="padding: 18px 16px; color: #475569; font-size: 16px; font-weight: 600;">
					${texto}
				</div>
			</div>`;
	}

	private getGeocodigoFeature(feature?: Feature<Geometry, any>): number {
		return Number(feature?.properties?.id);
	}

	private getDadoMunicipioPorFeature(
		feature?: Feature<Geometry, any>
	): ValorPorGeocodigo | undefined {
		return this.getDadoMunicipioPorGeocodigo(this.getGeocodigoFeature(feature));
	}

	private getDadoMunicipioPorGeocodigo(
		geocodigo: number
	): ValorPorGeocodigo | undefined {
		return this.chuvaPorMunicipio.find(
			municipio => Number(municipio.geocodigo) === Number(geocodigo)
		);
	}

	private getIdRegiaoFeature(feature?: Feature<Geometry, any>): number {
		return Number(feature?.properties?.['N°'] ?? feature?.properties?.['NÂ°']);
	}

	private getRegiaoPorFeature(
		feature?: Feature<Geometry, any>
	): Select | undefined {
		const nomeRegiao = feature?.properties?.name ?? '';
		const regiaoPorNome = this.regioes.find(
			item => this.normalizarNome(item.name) === this.normalizarNome(nomeRegiao)
		);
		if (regiaoPorNome) return regiaoPorNome;

		const idRegiao = this.getIdRegiaoFeature(feature);
		if (idRegiao) {
			const regiaoPorId = this.regioes.find(
				item => Number(item.value) === idRegiao
			);
			if (regiaoPorId) return regiaoPorId;
		}

		return undefined;
	}

	private getDadosRegiaoFeature(
		feature?: Feature<Geometry, any>
	): ValorPorGeocodigo[] {
		return this.getDadosRegiao(
			feature?.properties?.name ?? '',
			this.getRegiaoPorFeature(feature)?.value
		);
	}

	private getPrecipitacaoMediaRegiao(
		feature?: Feature<Geometry, any>
	): number | undefined {
		const dados = this.getDadosRegiaoFeature(feature).filter(dado =>
			isNotNuloOuUndefined(dado.valor)
		);

		if (!dados.length) return undefined;

		const total = dados.reduce((acc, dado) => acc + Number(dado.valor), 0);
		return total / dados.length;
	}

	private getCorRegiaoPluviometricaPorMm(
		feature?: Feature<Geometry, any>
	): string {
		const precipitacao = this.getPrecipitacaoMediaRegiao(feature);

		if (!isNotNuloOuUndefined(precipitacao)) {
			return CORES.CINZA;
		}

		const valor = Number(precipitacao);
		const thresholds = this.valoresLegendaEscalaPluviometrica.map(item =>
			Number(item.replace(',', '.'))
		);
		let indiceCor = 0;

		thresholds.forEach((threshold, index) => {
			if (valor >= threshold) {
				indiceCor = index;
			}
		});

		return this.coresLegendaEscalaPluviometrica[indiceCor];
	}

	private getIndiceCorDominanteRegiaoFeature(
		feature?: Feature<Geometry, any>
	): number {
		return this.getIndiceCorDominanteRegiao(
			feature?.properties?.name ?? '',
			this.getRegiaoPorFeature(feature)?.value
		);
	}

	private getIndiceCorDominanteRegiao(
		nomeRegiao: string,
		idRegiao?: string | number
	): number {
		const dadosRegiao = this.getDadosRegiao(nomeRegiao, idRegiao);

		if (!dadosRegiao.length) {
			return 5;
		}

		const totais = [0, 0, 0, 0, 0, 0];
		dadosRegiao.forEach(dado => {
			totais[this.getIndiceCorQuantis(dado)]++;
		});

		let maiorIndice = 5;
		let maiorTotal = 0;
		totais.forEach((total, indice) => {
			if (indice !== 5 && total > maiorTotal) {
				maiorTotal = total;
				maiorIndice = indice;
			}
		});

		return maiorIndice;
	}

	private getDadosRegiao(
		nomeRegiao: string,
		idRegiao?: string | number
	): ValorPorGeocodigo[] {
		const regiao = idRegiao
			? this.regioes.find(item => Number(item.value) === Number(idRegiao))
			: this.regioes.find(
					item =>
						this.normalizarNome(item.name) === this.normalizarNome(nomeRegiao)
			  );

		if (!regiao) {
			return [];
		}

		const dadosPorIdRegiao = this.chuvaPorMunicipio.filter(
			municipio =>
				Number(municipio.data?.regiaId ?? municipio.data?.regiaoId) ===
				Number(regiao.value)
		);

		if (dadosPorIdRegiao.length) {
			return dadosPorIdRegiao;
		}

		const geocodigosRegiao = this.inputs.municipios
			.filter(municipio => Number(municipio.regiao) === Number(regiao.value))
			.map(municipio => municipio.geocodigo);

		return this.chuvaPorMunicipio.filter(municipio =>
			geocodigosRegiao.map(Number).includes(Number(municipio.geocodigo))
		);
	}

	private getIndiceCorQuantis(dadoMunicipio?: ValorPorGeocodigo): number {
		if (
			!dadoMunicipio?.ranges?.length ||
			isNuloOuUndefined(dadoMunicipio.valor)
		) {
			return 5;
		}

		for (const range of dadoMunicipio.ranges) {
			if (dadoMunicipio.valor <= range.muitoSeco) {
				return 0;
			}
			if (
				dadoMunicipio.valor > range.muitoSeco &&
				dadoMunicipio.valor <= range.seco
			) {
				return 1;
			}
			if (
				dadoMunicipio.valor > range.seco &&
				dadoMunicipio.valor <= range.normal
			) {
				return 2;
			}
			if (
				dadoMunicipio.valor > range.normal &&
				dadoMunicipio.valor <= range.chuvoso
			) {
				return 3;
			}
			if (dadoMunicipio.valor > range.chuvoso) {
				return 4;
			}
		}

		return 5;
	}

	private atualizarLegendaMapaLeaflet(
		estadoCompleto: boolean,
		porMunicipio: boolean
	) {
		const legenda = this.getLegendaQuantisZerada();

		if (estadoCompleto) {
			this.inputs.municipios.forEach(municipio => {
				const dadoMunicipio = this.getDadoMunicipioPorGeocodigo(
					Number(municipio.geocodigo)
				);
				legenda[this.getIndiceCorQuantis(dadoMunicipio)].index++;
			});
		} else if (!porMunicipio) {
			legenda[this.getIndiceCorDominanteRegiao(this.microrregiaoNome)].index++;
		} else {
			const geocodigosRecorte = this.geocodigosRecorteMapa ?? [];
			geocodigosRecorte.forEach(geocodigo => {
				const dadoMunicipio = this.getDadoMunicipioPorGeocodigo(geocodigo);
				legenda[this.getIndiceCorQuantis(dadoMunicipio)].index++;
			});
		}

		this.legendaItems = legenda;
	}

	private getLegendaQuantisZerada(): LegendaItem[] {
		return [
			{ color: CORES.VERMELHO, label: 'Muito seco', index: 0 },
			{ color: CORES.AMARELO, label: 'Seco', index: 0 },
			{ color: CORES.VERDE, label: 'Normal', index: 0 },
			{ color: CORES.AZUL, label: 'Chuvoso', index: 0 },
			{ color: CORES.AZUL_ESCURO, label: 'Muito chuvoso', index: 0 },
			{ color: CORES.CINZA, label: 'Sem informação', index: 0 },
		];
	}

	private normalizarNome(v: string): string {
		return (v ?? '')
			.toString()
			.trim()
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '');
	}

	private atualizarConfiguracaoMapaRegiaoPluviometrica(
		valorAgrupamento: number
	) {
		if (this.getAgrupamentoSelecionado() !== 'REGIAO_PLUVIOMETRICA') {
			this.delimitarRegioesMapa = false;
			this.informacoesRegioesMapa = [];
			return;
		}

		this.informacoesRegioesMapa = this.getInformacoesRegioesPluviometricas();
		this.delimitarRegioesMapa = valorAgrupamento === 0;
	}

	private getInformacoesRegioesPluviometricas() {
		return this.regioes
			.filter(regiao => regiao.value !== '0')
			.map(regiao => ({
				idRegiao: regiao.value,
				nomeRegiao: regiao.name,
				geocodigos: this.inputs.municipios
					.filter(
						municipio => Number(municipio.regiao) === Number(regiao.value)
					)
					.map(municipio => municipio.geocodigo),
			}))
			.filter(regiao => regiao.geocodigos.length);
	}

	get microrregiaoParaMapa(): string | undefined {
		return this.getAgrupamentoSelecionado() === 'MICRORREGIAO'
			? this.microrregiaoNome
			: undefined;
	}

	get usarMapaLeafletRegiaoPluviometrica(): boolean {
		return this.getAgrupamentoSelecionado() === 'REGIAO_PLUVIOMETRICA';
	}

	get exibirLegendaEscalaEstadoCompletoRegiaoPluviometrica(): boolean {
		return (
			this.usarMapaLeafletRegiaoPluviometrica &&
			this.inputs.form.get(FormularioRelatorio.REGIAO_PLUVIOMETRICA)?.value ===
				'0'
		);
	}

	getTipo(): string {
		return this.inputs.form.get('periodoBusca')?.value === 'mensal'
			? 'QUANTIS_MENSAL'
			: 'QUANTIS_ANUAL';
	}

	handleLegendaItems(legendaItems: LegendaItem[]) {
		this.legendaItems = legendaItems;
	}

	precipitacaoAcumuladaPorGeocodigo(geocodigo: string) {
		const precipitacao = this.chuvaPorMunicipio.find(
			municipio => municipio.geocodigo === +geocodigo
		)?.valor;

		return numberToBrNumber(precipitacao, 1);
	}

	getTituloLegenda() {
		const unidadeMap = new Map([
			['QUANTIS_MENSAL', 'Quantis mensal'],
			['QUANTIS_ANUAL', 'Quantis anual'],
		]);
		return unidadeMap.get(this.getTipo()) ?? '';
	}

	async getMapImage(): Promise<MapCapture | null> {
		if (this.usarMapaLeafletRegiaoPluviometrica) {
			await new Promise(
				resolve => this.mapaRegiaoPluviometrica?.whenReady(() => resolve(true))
			);
		}

		const root = document.getElementById('mapa-legenda');
		if (!root) return null;

		this.isExporting = true;
		root.classList.add('export-mode');
		let restoreMobileLayout: (() => void) | null = null;

		if (this.geoJsonRegiaoPluviometrica) {
			this.geoJsonRegiaoPluviometrica.setStyle((feature: any) =>
				this.mapaLeafletPorMunicipio
					? this.estiloMunicipioQuantis(feature)
					: this.estiloRegiaoPluviometrica(feature)
			);
		}

		try {
			restoreMobileLayout = await this.ajustarLayoutMobileParaExportacao(root);
			this.prepararMapaParaExportacao();
			await this.esperarRenderizacaoMapa();

			const canvas = await html2canvas(root, {
				useCORS: true,
				allowTaint: true,
				logging: false,
				scale: this.exportScale,
				ignoreElements: element =>
					element.classList?.contains('leaflet-popup') ||
					element.classList?.contains('leaflet-popup-pane') ||
					element.classList?.contains('mapa-quantis-popup'),
				windowWidth: this.isMobileViewport()
					? this.exportDesktopWidth
					: window.innerWidth,
			});

			const mapaEl = (root.querySelector('.leaflet-container') ??
				root.querySelector('#map-container') ??
				root) as HTMLElement;
			const rootRect = root.getBoundingClientRect();
			const mapRectDom = mapaEl.getBoundingClientRect();

			const relLeft = mapRectDom.left - rootRect.left;
			const relTop = mapRectDom.top - rootRect.top;
			const contentRect = this.getRectConteudoMapaParaExportacao(
				relLeft,
				relTop
			);

			return {
				dataUrl: canvas.toDataURL('image/png', 1),
				canvasW: canvas.width,
				canvasH: canvas.height,
				mapRect: {
					x: relLeft * this.exportScale,
					y: relTop * this.exportScale,
					w: mapRectDom.width * this.exportScale,
					h: mapRectDom.height * this.exportScale,
				},
				contentRect,
			};
		} finally {
			if (restoreMobileLayout) restoreMobileLayout();
			this.isExporting = false;
			root.classList.remove('export-mode');
			if (this.geoJsonRegiaoPluviometrica) {
				this.geoJsonRegiaoPluviometrica.setStyle((feature: any) =>
					this.mapaLeafletPorMunicipio
						? this.estiloMunicipioQuantis(feature)
						: this.estiloRegiaoPluviometrica(feature)
				);
			}
		}
	}

	private deveRecentralizarMapaNaExportacao(): boolean {
		return (
			this.getAgrupamentoSelecionado() === 'REGIAO_PLUVIOMETRICA' &&
			this.usarMapaLeafletRegiaoPluviometrica &&
			!!this.mapaRegiaoPluviometrica &&
			!!this.geoJsonRegiaoPluviometrica
		);
	}

	private getRectConteudoMapaParaExportacao(
		relLeft: number,
		relTop: number
	): MapCapture['contentRect'] {
		if (!this.deveRecentralizarMapaNaExportacao()) {
			return undefined;
		}

		let minX = Number.POSITIVE_INFINITY;
		let minY = Number.POSITIVE_INFINITY;
		let maxX = Number.NEGATIVE_INFINITY;
		let maxY = Number.NEGATIVE_INFINITY;

		this.geoJsonRegiaoPluviometrica?.eachLayer((layer: any) => {
			if (!layer?.getBounds) {
				return;
			}

			const bounds = layer.getBounds();
			if (!bounds?.isValid?.()) {
				return;
			}

			const northWest = this.mapaRegiaoPluviometrica.latLngToContainerPoint(
				bounds.getNorthWest()
			);
			const southEast = this.mapaRegiaoPluviometrica.latLngToContainerPoint(
				bounds.getSouthEast()
			);

			minX = Math.min(minX, northWest.x);
			minY = Math.min(minY, northWest.y);
			maxX = Math.max(maxX, southEast.x);
			maxY = Math.max(maxY, southEast.y);
		});

		if (
			!Number.isFinite(minX) ||
			!Number.isFinite(minY) ||
			!Number.isFinite(maxX) ||
			!Number.isFinite(maxY)
		) {
			return undefined;
		}

		const containerSize = this.mapaRegiaoPluviometrica.getSize();
		const padding = this.mapaLeafletPorMunicipio ? 10 : 16;
		const x = Math.max(0, minX - padding);
		const y = Math.max(0, minY - padding);
		const maxWidth = containerSize.x;
		const maxHeight = containerSize.y;
		const w = Math.max(1, Math.min(maxWidth, maxX + padding) - x);
		const h = Math.max(1, Math.min(maxHeight, maxY + padding) - y);

		return {
			x: (relLeft + x) * this.exportScale,
			y: (relTop + y) * this.exportScale,
			w: w * this.exportScale,
			h: h * this.exportScale,
		};
	}

	private getCorFundoMapaExportado(
		ctx: CanvasRenderingContext2D,
		contentRect: NonNullable<MapCapture['contentRect']>
	): string {
		const pontos = [
			[
				Math.max(0, Math.floor(contentRect.x)),
				Math.max(0, Math.floor(contentRect.y)),
			],
			[
				Math.max(0, Math.floor(contentRect.x + contentRect.w - 1)),
				Math.max(0, Math.floor(contentRect.y)),
			],
			[
				Math.max(0, Math.floor(contentRect.x)),
				Math.max(0, Math.floor(contentRect.y + contentRect.h - 1)),
			],
			[
				Math.max(0, Math.floor(contentRect.x + contentRect.w - 1)),
				Math.max(0, Math.floor(contentRect.y + contentRect.h - 1)),
			],
		];

		let r = 0;
		let g = 0;
		let b = 0;
		let total = 0;

		pontos.forEach(([x, y]) => {
			const pixel = ctx.getImageData(x, y, 1, 1).data;
			r += pixel[0];
			g += pixel[1];
			b += pixel[2];
			total += 1;
		});

		if (!total) {
			return '#ffffff';
		}

		return `rgb(${Math.round(r / total)}, ${Math.round(
			g / total
		)}, ${Math.round(b / total)})`;
	}

	private recentralizarMapaNoCanvasExportado(
		ctx: CanvasRenderingContext2D,
		capture: MapCapture
	) {
		if (!this.deveRecentralizarMapaNaExportacao() || !capture.contentRect) {
			return;
		}

		const src = capture.contentRect;
		const dst = capture.mapRect;
		const padding = Math.max(18, Math.round(Math.min(dst.w, dst.h) * 0.045));
		const availableWidth = Math.max(1, dst.w - padding * 2);
		const availableHeight = Math.max(1, dst.h - padding * 2);
		const scale = Math.min(availableWidth / src.w, availableHeight / src.h);

		const destWidth = src.w * scale;
		const destHeight = src.h * scale;
		const destX = dst.x + (dst.w - destWidth) / 2;
		const destY = dst.y + (dst.h - destHeight) / 2;
		const background = this.getCorFundoMapaExportado(ctx, src);

		const tempCanvas = document.createElement('canvas');
		tempCanvas.width = Math.max(1, Math.round(src.w));
		tempCanvas.height = Math.max(1, Math.round(src.h));
		const tempCtx = tempCanvas.getContext('2d');
		if (!tempCtx) {
			return;
		}

		tempCtx.drawImage(
			ctx.canvas,
			src.x,
			src.y,
			src.w,
			src.h,
			0,
			0,
			tempCanvas.width,
			tempCanvas.height
		);

		ctx.save();
		ctx.fillStyle = background;
		ctx.fillRect(dst.x, dst.y, dst.w, dst.h);
		ctx.drawImage(tempCanvas, destX, destY, destWidth, destHeight);
		ctx.restore();
	}

	private async ajustarLayoutMobileParaExportacao(
		root: HTMLElement
	): Promise<(() => void) | null> {
		if (!this.isMobileViewport()) return null;

		const mapaWrapper = root.querySelector(
			'.mapa-wrapper'
		) as HTMLElement | null;
		const mapaLeaflet = root.querySelector(
			'.leaflet-container'
		) as HTMLElement | null;

		const rootPrev = {
			width: root.style.width,
			minWidth: root.style.minWidth,
			maxWidth: root.style.maxWidth,
		};

		const wrapperPrev = mapaWrapper
			? {
					height: mapaWrapper.style.height,
					minHeight: mapaWrapper.style.minHeight,
			  }
			: null;

		const leafletPrev = mapaLeaflet
			? {
					height: mapaLeaflet.style.height,
			  }
			: null;

		root.style.width = `${this.exportDesktopWidth}px`;
		root.style.minWidth = `${this.exportDesktopWidth}px`;
		root.style.maxWidth = `${this.exportDesktopWidth}px`;

		if (mapaWrapper) {
			mapaWrapper.style.height = `${this.exportMapHeight}px`;
			mapaWrapper.style.minHeight = `${this.exportMapHeight}px`;
		}

		if (mapaLeaflet) {
			mapaLeaflet.style.height = `${this.exportMapHeight}px`;
		}

		this.mapaRegiaoPluviometrica?.invalidateSize(true);
		await this.esperarRenderizacaoMapa();

		return () => {
			root.style.width = rootPrev.width;
			root.style.minWidth = rootPrev.minWidth;
			root.style.maxWidth = rootPrev.maxWidth;

			if (mapaWrapper && wrapperPrev) {
				mapaWrapper.style.height = wrapperPrev.height;
				mapaWrapper.style.minHeight = wrapperPrev.minHeight;
			}

			if (mapaLeaflet && leafletPrev) {
				mapaLeaflet.style.height = leafletPrev.height;
			}

			this.mapaRegiaoPluviometrica?.invalidateSize(true);
		};
	}

	private async esperarRenderizacaoMapa() {
		await new Promise<void>(r => requestAnimationFrame(() => r()));
		await new Promise<void>(r => requestAnimationFrame(() => r()));
		await new Promise<void>(r => setTimeout(() => r(), 100));
	}

	private prepararMapaParaExportacao() {
		if (
			!this.usarMapaLeafletRegiaoPluviometrica ||
			!this.mapaRegiaoPluviometrica
		) {
			return;
		}

		this.mapaRegiaoPluviometrica.invalidateSize(true);

		const bounds = this.geoJsonRegiaoPluviometrica?.getBounds();
		if (bounds?.isValid()) {
			this.mapaRegiaoPluviometrica.setMinZoom(0);
			this.mapaRegiaoPluviometrica.setMaxZoom(18);
			this.mapaRegiaoPluviometrica.fitBounds(bounds, {
				padding: this.mapaLeafletPorMunicipio ? [8, 8] : [20, 20],
				maxZoom: this.mapaLeafletPorMunicipio ? 10 : 8,
				animate: false,
			});
			this.mapaRegiaoPluviometrica.panTo(bounds.getCenter(), {
				animate: false,
			});
			const zoomAtual = this.mapaRegiaoPluviometrica.getZoom();
			this.mapaRegiaoPluviometrica.setMinZoom(zoomAtual);
			this.mapaRegiaoPluviometrica.setMaxZoom(zoomAtual);
		}
		this.agendarLimpezaCamadasBaseMapaQuantis();
		this.bloquearInteracaoMapaLeaflet();
	}

	private resolveAsset(path: string): string {
		return new URL(path, document.baseURI).toString();
	}

	private carregarImagem(src: string): Promise<HTMLImageElement> {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.crossOrigin = 'anonymous';
			image.onload = () => resolve(image);
			image.onerror = err => reject(err);
			image.src = src;
		});
	}

	private async montarMapaComLogos(
		capture: MapCapture,
		opts?: { showHeader?: boolean; showPeriodo?: boolean }
	): Promise<string> {
		const showHeader = opts?.showHeader ?? true;
		const showPeriodo = opts?.showPeriodo ?? true;

		const logoGovernoSrc = this.resolveAsset(
			'assets/images/logos/governo_pb.png'
		);
		const logoAesaSrc = this.resolveAsset('assets/images/logos/logoAesa.svg');

		const results = await Promise.allSettled([
			this.carregarImagem(capture.dataUrl),
			this.carregarImagem(logoGovernoSrc),
			this.carregarImagem(logoAesaSrc),
		]);

		const mapImage =
			results[0].status === 'fulfilled' ? results[0].value : null;
		const logoGov = results[1].status === 'fulfilled' ? results[1].value : null;
		const logoAesa =
			results[2].status === 'fulfilled' ? results[2].value : null;

		if (!mapImage) return capture.dataUrl;

		const offsetY = showHeader ? 170 : 0;
		const footerH = 150;
		const canvas = document.createElement('canvas');
		canvas.width = mapImage.naturalWidth;
		canvas.height = mapImage.naturalHeight + offsetY + footerH;

		const ctx = canvas.getContext('2d')!;
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		ctx.drawImage(mapImage, 0, offsetY);
		this.recentralizarMapaNoCanvasExportado(ctx, {
			...capture,
			mapRect: {
				...capture.mapRect,
				y: capture.mapRect.y + offsetY,
			},
			contentRect: capture.contentRect
				? {
						...capture.contentRect,
						y: capture.contentRect.y + offsetY,
				  }
				: undefined,
		});

		const mapX0 = capture.mapRect.x;
		const mapX1 = mapX0 + capture.mapRect.w;

		if (showHeader) {
			const headerH = offsetY;

			ctx.save();
			ctx.fillStyle = '#ffffff';
			ctx.fillRect(0, 0, canvas.width, headerH);
			ctx.strokeStyle = 'rgba(17,24,39,0.12)';
			ctx.lineWidth = 1;
			ctx.beginPath();
			ctx.moveTo(0, headerH - 0.5);
			ctx.lineTo(canvas.width, headerH - 0.5);
			ctx.stroke();

			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = '#111827';
			ctx.font = `700 ${Math.max(
				24,
				Math.min(38, Math.round(headerH * 0.22))
			)}px Poppins, Arial, sans-serif`;
			ctx.fillText(this.getTituloLegenda(), canvas.width / 2, headerH * 0.33);

			if (showPeriodo && this.tituloQuantis.trim()) {
				ctx.font = `600 ${Math.max(
					24,
					Math.min(38, Math.round(headerH * 0.22))
				)}px Poppins, Arial, sans-serif`;
				ctx.fillText(this.tituloQuantis, canvas.width / 2, headerH * 0.64);
			}
			ctx.restore();
		}

		const footerY = offsetY + mapImage.naturalHeight;
		ctx.save();
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, footerY, canvas.width, footerH);
		ctx.strokeStyle = 'rgba(17,24,39,0.10)';
		ctx.lineWidth = 1;
		ctx.beginPath();
		ctx.moveTo(0, footerY + 0.5);
		ctx.lineTo(canvas.width, footerY + 0.5);
		ctx.stroke();

		const footerPad = Math.max(80, Math.round(canvas.width * 0.07));
		const maxLogoH = 85;
		const drawLogoFooter = (
			imgEl: HTMLImageElement,
			x: number,
			align: 'left' | 'right'
		) => {
			const ratio = imgEl.naturalWidth / imgEl.naturalHeight;
			const h = maxLogoH;
			const w = Math.round(h * ratio);
			const y = footerY + Math.round((footerH - h) / 2);
			const xFinal = align === 'left' ? x : x - w;

			ctx.drawImage(imgEl, xFinal, y, w, h);
		};

		if (logoAesa) {
			drawLogoFooter(logoAesa, mapX0 + footerPad, 'left');
		}

		if (logoGov) {
			drawLogoFooter(logoGov, mapX1 - footerPad, 'right');
		}
		ctx.restore();

		return canvas.toDataURL('image/png', 1);
	}

	getDadosTabelaParaExportacao(isPdf: boolean) {
		const tableData: any[][] = [];

		if (this.getTipo() === 'QUANTIS_MENSAL') {
			const colunas = [
				{ text: 'Município', fillColor: '#DCDCDC' },
				{
					text: 'Precipitação acumulada (mm)',
					fillColor: '#DCDCDC',
					alignment: 'center',
				},
				{ text: 'Data', fillColor: '#DCDCDC', alignment: 'center' },
			];

			verificaSePDFEAdicionaNaTabela(tableData, colunas, isPdf);

			this.getPrecipitacoesMunicipiosParaExportacao(
				this.dadosMapaQuantis
			).forEach(precipitacaoMunicipio => {
				const rowData = [
					precipitacaoMunicipio.nomeMunicipio,
					alinharDado(
						this.formatarValorQuantisExportacaoTexto(
							precipitacaoMunicipio.precipitacaoAcumulada
						),
						isPdf
					),
					alinharDado(
						DateTimeUtils.getMesNumericoEAno(
							new Date(precipitacaoMunicipio.periodo)
						),
						isPdf
					),
				];

				tableData.push(rowData);
			});
		} else {
			const colunas = [
				{ text: 'Município', fillColor: '#DCDCDC' },
				{
					text: 'Precipitação acumulada (mm)',
					fillColor: '#DCDCDC',
					alignment: 'center',
				},
				{ text: 'Data', fillColor: '#DCDCDC', alignment: 'center' },
			];

			verificaSePDFEAdicionaNaTabela(tableData, colunas, isPdf);

			this.getPrecipitacoesMunicipiosParaExportacao(
				this.chuvasPorMicrorregiao
			).forEach(precipitacaoMunicipio => {
				const rowData = [
					precipitacaoMunicipio.nomeMunicipio,
					alinharDado(
						this.formatarValorQuantisExportacaoTexto(
							precipitacaoMunicipio.precipitacaoAcumulada
						),
						isPdf
					),
					alinharDado(
						new Date(precipitacaoMunicipio.periodo).getFullYear(),
						isPdf
					),
				];
				tableData.push(rowData);
			});
		}

		return tableData;
	}

	retornarQuantisParaXLSX() {
		const tableData: any[] = [];

		const precipitacoesMunicipios =
			this.getPrecipitacoesMunicipiosParaExportacao(
				this.getTipo() === 'QUANTIS_MENSAL'
					? this.dadosMapaQuantis
					: this.chuvasPorMicrorregiao
			);

		precipitacoesMunicipios.forEach(precipitacaoMunicipio => {
			tableData.push({
				municipio: precipitacaoMunicipio.nomeMunicipio,
				precipitacaoAcumulada: isNuloOuUndefined(
					precipitacaoMunicipio.precipitacaoAcumulada
				)
					? '-'
					: precipitacaoMunicipio.precipitacaoAcumulada,
				periodo:
					this.getTipo() === 'QUANTIS_MENSAL'
						? DateTimeUtils.getMesNumericoEAno(
								new Date(precipitacaoMunicipio.periodo)
						  )
						: DateTimeUtils.getAno(precipitacaoMunicipio.periodo),
			});
		});

		return tableData;
	}

	private getColunasQuantisParaXLSX() {
		if (this.deveAplicarAjustesExportacaoRegiaoPluviometrica()) {
			return [
				{
					key: 'municipio',
				},
				{
					key: 'precipitacaoAcumulada',
					style: { numFmt: '0.0' },
				},
				{
					key: 'periodo',
				},
			];
		}

		return [
			{
				key: 'municipio',
				style: { numFmt: '0.0' },
			},
			{
				key: 'precipitacaoAcumulada',
				style: { numFmt: '0.0' },
			},
			{
				key: 'periodo',
			},
		];
	}

	async exportarPDF() {
		this.prepararMapaParaExportacao();
		await new Promise(resolve => setTimeout(resolve, 750));

		try {
			this.esconderElementosDaExportacao();
			await new Promise(resolve => setTimeout(resolve, 250));

			const documentDefinition: any = await pdfseira.documentDefinitions(
				'portrait'
			);
			const capture = await this.getMapImage();
			if (!capture) {
				this.toastr.error('NÃ£o foi possÃ­vel capturar o mapa para PDF.');
				return;
			}

			const imgDataUrl = await this.montarMapaComLogos(capture, {
				showHeader: false,
				showPeriodo: false,
			});

			documentDefinition.content.push([
				{
					text: this.tituloQuantis,
					alignment: 'center',
					margin: [0, 6, 0, 6],
				},
				{
					image: imgDataUrl,
					fit: [500, 520],
					margin: [0, 0, 0, 8],
					alignment: 'center',
				},
			]);

			const tableData = this.getDadosTabelaParaExportacao(true);

			documentDefinition.content.push({
				table: {
					widths: ['33%', '33%', '33%'],
					body: tableData,
					layout: {
						noWrap: false,
						fontSize: 5,
					},
				},
			});

			baixarEAbrirPDF(this.tituloQuantis, documentDefinition);
		} finally {
			this.mostrarElementosDaExportacao();
		}
	}

	exportarCSV() {
		const tableData = this.getDadosTabelaParaExportacao(false);

		DocumentExporter.gerarCSV(tableData, this.tituloQuantis);
	}

	exportarTXT() {
		const tableData = this.getDadosTabelaParaExportacao(false);

		let txtData = '';
		if (tableData.length > 0) {
			const colunas = tableData[0];

			tableData.slice(1).forEach(dadoRelatorio => {
				colunas.forEach((coluna: string, index: number) => {
					const valor = dadoRelatorio[index];
					txtData += `${coluna}: ${valor ?? '-'}\n`;
				});

				txtData += '\n';
			});
		}

		DocumentExporter.gerarTXT(txtData, this.tituloQuantis);
	}

	async exportarXLSX() {
		const nomeArquivo = this.tituloQuantis;

		const colorPalette = {
			c1: '2C3639',
			c2: 'FFFFFF',
			c3: '000000',
			c4: 'EEEEEE',
		};

		const rowStyle = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
		};
		const rowStyleDecimal1 = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			format: 'num_sep_1',
		};
		const headerStyle = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
		};
		const headerStyleCenter = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const rowStyleCenter = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const rowStyleCenterDecimal1 = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			format: 'num_sep_1',
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};

		const title = {
			backgroundColor: colorPalette.c2,
			whiteSpace: 'pre',
			color: colorPalette.c3,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1,
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const aplicarAjustesExportacaoRegiaoPluviometrica =
			this.deveAplicarAjustesExportacaoRegiaoPluviometrica();

		let headers = [];
		let columns = [];

		if (this.getTipo() === 'QUANTIS_MENSAL') {
			headers = [
				{
					label: 'municipio',
					text: 'Município',
					size: 24,
				},
				{
					label: 'precipitacaoAcumulada',
					text: 'Precipitação acumulada (mm)',
					size: 24,
				},
				{
					label: 'periodo',
					text: 'Data',
					size: 24,
				},
			];

			columns = this.getColunasQuantisParaXLSX();
		} else {
			headers = [
				{
					label: 'municipio',
					text: 'Município',
					size: 24,
				},
				{
					label: 'precipitacaoAcumulada',
					text: 'Precipitação acumulada (mm)',
					size: 24,
				},
				{
					label: 'periodo',
					text: 'Data',
					size: 24,
				},
			];

			columns = this.getColunasQuantisParaXLSX();
		}

		const dataExcel = {
			styles: {
				headerStyle,
				headerStyleCenter,
				rowStyle,
				rowStyleDecimal1,
				rowStyleCenter,
				rowStyleCenterDecimal1,
				title,
			},
			sheet: [
				{
					shiftTop: 3,
					images: [
						{
							url: 'assets/images/cabecalho/cabeçalho_excel.png',
							from: 'A1',
							to: 'C3',
						},
					],
					styleCellCondition(
						data: any,
						object: any,
						rowIndex: number,
						colIndex: number,
						fromHeader: boolean,
						styleKeys: string[]
					) {
						if (data && data.label) {
							return 'headerStyleCenter';
						} else {
							if (
								colIndex === 1 &&
								aplicarAjustesExportacaoRegiaoPluviometrica &&
								typeof data === 'number'
							) {
								return 'rowStyleCenterDecimal1';
							}
							if (colIndex > 0) {
								return 'rowStyleCenter';
							} else {
								return 'rowStyle';
							}
						}
					},
					headers: headers,
					data: this.retornarQuantisParaXLSX(),
					columns: columns,
					title: {
						consommeRow: 3,
						consommeCol: 3,
						text: nomeArquivo,
						styleId: 'title',
					},
				},
			],
			fileName: nomeArquivo,
		};

		await ExcelTable.generateExcel(dataExcel);
	}
	private downloadDataUrl(nomeArquivoSemExt: string, dataUrl: string) {
		const a = document.createElement('a');
		a.href = dataUrl;
		a.download = `${nomeArquivoSemExt}.png`;
		a.style.display = 'none';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	private async exportarPNGLegado(nomeArquivo?: string, delayMs = 200) {
		try {
			const wrapperDataUrl = (await this.getMapImage())?.dataUrl;
			if (!wrapperDataUrl) {
				this.toastr.error('Não foi possível capturar o mapa para PNG.');
				return;
			}

			const carregarImagem = (src: string): Promise<HTMLImageElement> => {
				return new Promise((resolve, reject) => {
					const img = new Image();
					img.crossOrigin = 'anonymous';
					img.onload = () => resolve(img);
					img.onerror = err => reject(err);
					img.src = src;
				});
			};

			const baseImg = await carregarImagem(wrapperDataUrl);

			const canvas = document.createElement('canvas');
			canvas.width = baseImg.width;
			canvas.height = baseImg.height;

			const ctx = canvas.getContext('2d')!;

			ctx.fillStyle = '#FFFFFF';
			ctx.fillRect(0, 0, canvas.width, canvas.height);

			ctx.drawImage(baseImg, 0, 0, canvas.width, canvas.height);

			try {
				const logoAesa = await carregarImagem('assets/images/logos/aesa.png');

				const margem = canvas.width * 0.01;
				const larguraLogo = canvas.width * 0.04;
				const alturaLogo = (larguraLogo / logoAesa.width) * logoAesa.height;

				const xLogo = canvas.width - larguraLogo - margem;
				const yLogo = canvas.height - alturaLogo - margem;

				ctx.drawImage(logoAesa, xLogo, yLogo, larguraLogo, alturaLogo);
			} catch (e) {
				console.error('[QUANTIS PNG] Erro ao carregar logo AESA:', e);
			}

			const finalDataUrl = canvas.toDataURL('image/png', 1);
			const nome =
				nomeArquivo && nomeArquivo.trim().length
					? nomeArquivo
					: this.tituloQuantis && this.tituloQuantis.trim().length
					? this.tituloQuantis
					: 'Mapa de quantis';

			this.downloadDataUrl(nome, finalDataUrl);
		} catch (e) {
			console.error('[QUANTIS PNG] Erro ao gerar PNG:', e);
			this.toastr.error('Falha ao exportar PNG.');
		}
	}

	private async recortarDataUrlSides(
		dataUrl: string,
		rect: { x: number; y: number; w: number; h: number },
		pad: { top?: number; right?: number; bottom?: number; left?: number } = {}
	): Promise<string> {
		const img = await this.carregarImagem(dataUrl);

		const top = pad.top ?? 0;
		const right = pad.right ?? 0;
		const bottom = pad.bottom ?? 10;
		const left = pad.left ?? 0;

		const sx = Math.max(0, Math.floor(rect.x - left));
		const sy = Math.max(0, Math.floor(rect.y - top));
		const sw = Math.min(
			img.naturalWidth - sx,
			Math.floor(rect.w + left + right)
		);
		const sh = Math.min(
			img.naturalHeight - sy,
			Math.floor(rect.h + top + bottom)
		);

		const out = document.createElement('canvas');
		out.width = sw;
		out.height = sh;

		const ctx = out.getContext('2d')!;
		ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);

		return out.toDataURL('image/png', 1);
	}

	private isMobileViewport(): boolean {
		return window.matchMedia('(max-width: 768px)').matches;
	}

	private esconderElementosDaExportacao(): void {
		const seletores = [
			'.leaflet-control-container',
			'.leaflet-top',
			'.leaflet-bottom',
		];

		seletores.forEach(seletor => {
			document.querySelectorAll(seletor).forEach((el: Element) => {
				(el as HTMLElement).style.display = 'none';
			});
		});
	}

	private mostrarElementosDaExportacao(): void {
		const seletores = [
			'.leaflet-control-container',
			'.leaflet-top',
			'.leaflet-bottom',
		];

		seletores.forEach(seletor => {
			document.querySelectorAll(seletor).forEach((el: Element) => {
				(el as HTMLElement).style.display = '';
			});
		});
	}

	public async exportarPNG(nomeArquivo?: string) {
		this.prepararMapaParaExportacao();
		await new Promise(resolve => setTimeout(resolve, 750));

		try {
			this.esconderElementosDaExportacao();
			await new Promise(resolve => setTimeout(resolve, 200));

			const capture = await this.getMapImage();
			if (!capture) {
				this.toastr.error('Não foi possível capturar o mapa para PNG.');
				return;
			}

			const nome =
				nomeArquivo && nomeArquivo.trim().length
					? nomeArquivo
					: this.tituloQuantis && this.tituloQuantis.trim().length
					? this.tituloQuantis
					: 'Mapa de quantis';

			try {
				const dataUrlFinal = await this.montarMapaComLogos(capture);
				this.downloadDataUrl(nome, dataUrlFinal);
			} catch (e) {
				console.error('[QUANTIS PNG] Erro ao montar imagem:', e);
				this.downloadDataUrl(nome, capture.dataUrl);
			}
		} catch (e) {
			console.error('[QUANTIS PNG] Erro ao gerar PNG:', e);
			this.toastr.error('Falha ao exportar PNG.');
		} finally {
			this.mostrarElementosDaExportacao();
		}
	}
}
